import { render, staticRenderFns } from "./TpassReceiptRecord.vue?vue&type=template&id=b66aa7b2&scoped=true&"
import script from "./TpassReceiptRecord.vue?vue&type=script&lang=js&"
export * from "./TpassReceiptRecord.vue?vue&type=script&lang=js&"
import style0 from "./TpassReceiptRecord.vue?vue&type=style&index=0&id=b66aa7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66aa7b2",
  null
  
)

export default component.exports